// Sync customization checkboxes with hidden inputs inside the form
document.addEventListener('DOMContentLoaded', function() {
  // Find all customization checkboxes (those with form attribute)
  const customizationCheckboxes = document.querySelectorAll('input[type="checkbox"].checkbox_input[form]');
  
  customizationCheckboxes.forEach(function(checkbox) {
    const formId = checkbox.getAttribute('form');
    const propertyName = checkbox.getAttribute('name');
    const propertyValue = checkbox.value;
    
    // Find the target form
    const targetForm = document.getElementById(formId);
    if (!targetForm) return;
    
    // Find or create the customization properties container
    const containerId = 'customization-properties-data-' + formId.replace('product-form-', '');
    let container = document.getElementById(containerId);
    if (!container) {
      container = document.createElement('div');
      container.id = containerId;
      container.setAttribute('data-customization-properties-data', '');
      targetForm.appendChild(container);
    }
    
    // Create a hidden input for this checkbox
    const hiddenInput = document.createElement('input');
    hiddenInput.type = 'hidden';
    hiddenInput.name = propertyName;
    hiddenInput.value = 'No'; // Default to No
    hiddenInput.setAttribute('data-customization-sync', checkbox.id);
    container.appendChild(hiddenInput);
    
    // Sync function
    function syncCheckbox() {
      if (checkbox.checked) {
        hiddenInput.value = 'Yes';
      } else {
        hiddenInput.value = 'No';
      }
    }
    
    // Initial sync
    syncCheckbox();
    
    // Listen for changes
    checkbox.addEventListener('change', syncCheckbox);
  });
});
